import React, { useState, useEffect, useRef } from "react";
import UserService from "../services/user.service"; // Assuming UserService handles API calls
import { Alert, Button, Modal, Form, Spinner } from 'react-bootstrap';
import { LoadScript, GoogleMap, Autocomplete as GoogleAutocomplete } from '@react-google-maps/api';
import { buildPublicRedeemUrl } from "../utils/publicRedeemUrl";
import { FaQrcode, FaTag, FaCog, FaWhatsapp, FaTelegramPlane, FaDownload, FaMapMarkerAlt, FaShareAlt, FaUser } from 'react-icons/fa';

const MAP_LIBRARIES = ["places"];
const MAP_API_KEY = "AIzaSyDzLGEYu_8RPpFgtQZdhi9xS2HkGGUsb-k";


const batchURI= process.env.REACT_APP_API_BATCH_URL;
const directURI= process.env.REACT_APP_API_DIRECT_URL;
const BatchManagerCustomer = () => {
  const [batchCodes, setBatchCodes] = useState([]);
  const [formData, setFormData] = useState({
    batch_name: '',
    batch_code: '',
    buyer_id: '',
    order_id: '',
    batch_quantity: '',
    batch_validity_from_date: '',
    batch_validity_until_date: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiErrors, setApiErrors] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchOpen, setSearchOpen] = useState(false);
  const [pickedId, setPickedId] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedBatchCode, setSelectedBatchCode] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [placeModalOpen, setPlaceModalOpen] = useState(false);
  const [placeTargetId, setPlaceTargetId] = useState(null);
  const [placeForm, setPlaceForm] = useState({ place_id: '', place_name: '', place_address: '', latitude: '', longitude: '', tmp_json: '' });
  const [nearbyPlaces, setNearbyPlaces] = useState([]);
  const [nearbyLoading, setNearbyLoading] = useState(false);
  const [placeMap, setPlaceMap] = useState(null);
  const [markerPosition, setMarkerPosition] = useState({ lat: 50.9375, lng: 6.9603 });
  const placeCodeRef = useRef('');
  const placeAutocompleteRef = useRef(null);

  // Werbeplatz & Visitenkarte (Vorbild oi.gg)
  const [promoModalOpen, setPromoModalOpen] = useState(false);
  const [promoTargetCode, setPromoTargetCode] = useState(null);
  const [promoForm, setPromoForm] = useState({
    website_url: '',
    contact_phone: '',
    contact_whatsapp: '',
    promo_title: '',
    description: '',
    flyer_image_url: '',
    is_promo_active: true,
  });
  const [promoLoading, setPromoLoading] = useState(false);
  const [promoMessage, setPromoMessage] = useState('');
  const [promoError, setPromoError] = useState('');
  const [flyerFile, setFlyerFile] = useState(null);
  const [flyerUploading, setFlyerUploading] = useState(false);
  const [tariffCodeId, setTariffCodeId] = useState(null);
  const [settingsCode, setSettingsCode] = useState(null);
  const [shareCode, setShareCode] = useState(null);
  const [catalogOffers, setCatalogOffers] = useState([]);
  const [catalogReady, setCatalogReady] = useState(false);
  const [bookOffer, setBookOffer] = useState(null);
  const [bookPeriod, setBookPeriod] = useState("monthly");
  const [bookBusy, setBookBusy] = useState(false);
  const [focusId, setFocusId] = useState(null);
  const [billingPeriod, setBillingPeriod] = useState('monthly');
  const [offers, setOffers] = useState([]);
  const [offersLoading, setOffersLoading] = useState(false);
  const [pageTab, setPageTab] = useState("codes");
  const [actionBusy, setActionBusy] = useState(false);
  const [actionMessage, setActionMessage] = useState('');
  const [actionError, setActionError] = useState('');
  const [confirmAction, setConfirmAction] = useState('');

  const openPromoModal = async (batchCode) => {
    if (!batchCode || !batchCode.place_id) return;
    setPromoTargetCode(batchCode);
    setPromoMessage('');
    setPromoError('');
    setFlyerFile(null);
    setPromoLoading(true);
    setPromoModalOpen(true);
    try {
      const res = await UserService.getPromo(batchCode.place_id);
      const d = res.data || {};
      setPromoForm({
        website_url: d.website_url || '',
        contact_phone: d.contact_phone || '',
        contact_whatsapp: d.contact_whatsapp || '',
        promo_title: d.promo_title || '',
        description: d.description || '',
        flyer_image_url: d.flyer_image_url || '',
        is_promo_active: d.is_promo_active !== false && d.is_promo_active !== 0,
      });
    } catch (err) {
      setPromoError('Werbeplatzdaten konnten nicht geladen werden.');
    } finally {
      setPromoLoading(false);
    }
  };

  const handlePromoSubmit = async (e) => {
    e.preventDefault();
    if (!promoTargetCode || !promoTargetCode.place_id) return;
    setPromoLoading(true);
    setPromoMessage('');
    setPromoError('');
    try {
      await UserService.updatePromo(promoTargetCode.place_id, promoForm);
      setPromoMessage('Werbeplatzdaten erfolgreich gespeichert!');
    } catch (err) {
      setPromoError((err.response?.data?.message) || 'Fehler beim Speichern der Werbedaten.');
    } finally {
      setPromoLoading(false);
    }
  };

  const handleFlyerUpload = async () => {
    if (!flyerFile || !promoTargetCode?.place_id) return;
    setFlyerUploading(true);
    setPromoError('');
    setPromoMessage('');
    const fd = new FormData();
    fd.append('flyer', flyerFile);
    try {
      const res = await UserService.uploadPromoFlyer(promoTargetCode.place_id, fd);
      setPromoForm(prev => ({ ...prev, flyer_image_url: res.data.flyer_image_url }));
      setPromoMessage('Flyer erfolgreich hochgeladen!');
      setFlyerFile(null);
    } catch (err) {
      setPromoError((err.response?.data?.message) || 'Flyer-Upload fehlgeschlagen.');
    } finally {
      setFlyerUploading(false);
    }
  };

  const handleFlyerDelete = async () => {
    if (!promoTargetCode?.place_id) return;
    setFlyerUploading(true);
    setPromoError('');
    setPromoMessage('');
    try {
      await UserService.deletePromoFlyer(promoTargetCode.place_id);
      setPromoForm(prev => ({ ...prev, flyer_image_url: '' }));
      setPromoMessage('Flyer wurde entfernt.');
    } catch (err) {
      setPromoError('Fehler beim Entfernen des Flyers.');
    } finally {
      setFlyerUploading(false);
    }
  };


  useEffect(() => {
    loadBatchCodes();
    fetchEmployees();
  }, [currentPage]);

  useEffect(() => {
    let cancelled = false;
    UserService.getSelfServiceCatalog()
      .then((response) => {
        if (cancelled) return;
        const offers = response.data && Array.isArray(response.data.offers) ? response.data.offers : [];
        setCatalogOffers(offers);
      })
      .catch(() => {
        if (!cancelled) setCatalogOffers([]);
      })
      .finally(() => {
        if (!cancelled) setCatalogReady(true);
      });
    return () => { cancelled = true; };
  }, []);

  const loadBatchCodes = async () => {
    setApiErrors('');
    setErrors({});
    setLoading(true);
    try {
      const response = await UserService.getAllBatchCodes({
        page: currentPage,
        limit: 100,
        search: ''
      });
      setBatchCodes(response.data.batchCodes);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      setApiErrors('Die Chargen konnten nicht geladen werden.');
    } finally {
      setLoading(false);
    }
  };

  const fetchEmployees = async () => {
    setApiErrors('');
    setErrors({});
    setLoading(true);
    try {
      const response = await UserService.getMyEmployees();
    
      if (response?.data?.length > 0) {
        setEmployees(response.data);
        console.log(`Loaded ${response.data.length} employees`);
      } else {
        setEmployees([]); 
        console.log('No employees found');
      }
    } catch (error) {
      console.error('Error fetching employees:', error);
      //setApiErrors('Failed to load employees');
    } finally {
      setLoading(false);
    }
  }

  const handleEmployeeChange = (event, batchCodeId) => {
    console.log("handleEmployeeChange Event", event);
    console.log("handleEmployeeChange batchCodeId", batchCodeId);
  
    const selectedEmployeeId = event.target.value;
    console.log("handleEmployeeChange selectedEmployeeId", selectedEmployeeId);
  
    // Find the selected employee or default to null if not found
    const selectedEmployee = employees.find(emp => emp.employee_id === parseInt(selectedEmployeeId)) || { employee_id: null };
  
    console.log("handleEmployeeChange selectedEmployee", JSON.stringify(selectedEmployee, null, 2));
  
    // Update batchCode with selected employee details
    setBatchCodes((prevBatchCodes) =>
      prevBatchCodes.map((batch) =>
        batch.batch_code_id === batchCodeId
          ? {
              ...batch,
              t_employee: selectedEmployee
            }
          : batch
      )
    );
  
    // Send the employee data (if null, employee_id will be null)
    UserService.saveBatchCode(batchCodeId, selectedEmployee);
  
    console.log("handleEmployeeChange saved batchCodeId", batchCodeId);
  };
  
  

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setPickedId(null);
    setSearchOpen(true);
  };

  const openPlaceModal = (batchCode) => {
    placeCodeRef.current = batchCode.batch_code_id;
    setPlaceTargetId(batchCode.batch_code_id);
    setPlaceForm({ place_id: '', place_name: '', place_address: '', latitude: '', longitude: '', tmp_json: '' });
    setNearbyPlaces([]);
    setApiErrors('');
    setPlaceModalOpen(true);
  };

  const applyCustomerPlace = (place) => {
    if (!place || !place.geometry || !place.geometry.location) return;
    const details = {
      name: place.name || '',
      formattedAddress: place.formatted_address || '',
      placeId: place.place_id || '',
    };
    setMarkerPosition({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });
    setPlaceForm({
      place_id: place.place_id || '',
      place_name: place.name || '',
      place_address: place.formatted_address || '',
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng(),
      tmp_json: JSON.stringify(details),
    });
    setNearbyPlaces([]);
    if (placeMap) {
      placeMap.setCenter(place.geometry.location);
      placeMap.setZoom(16);
    }
  };

  const searchNearbyCompanies = (latLng) => {
    if (!placeMap || !window.google || !window.google.maps || !window.google.maps.places) {
      setApiErrors('Die Karte ist noch nicht bereit.');
      return;
    }
    setNearbyLoading(true);
    const service = new window.google.maps.places.PlacesService(placeMap);
    service.nearbySearch({ location: latLng, radius: 1200, type: 'establishment' }, (results, status) => {
      setNearbyLoading(false);
      if (status !== window.google.maps.places.PlacesServiceStatus.OK || !Array.isArray(results)) {
        setNearbyPlaces([]);
        setApiErrors('Im Umkreis wurden keine Unternehmen gefunden.');
        return;
      }
      setApiErrors('');
      setNearbyPlaces(results.slice(0, 12));
    });
  };

  const selectNearbyCompany = (result) => {
    if (!placeMap || !result || !window.google) return;
    const service = new window.google.maps.places.PlacesService(placeMap);
    service.getDetails({
      placeId: result.place_id,
      fields: ['place_id', 'name', 'formatted_address', 'geometry'],
    }, (place, status) => {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK || !place) {
        setApiErrors('Das Unternehmen konnte nicht übernommen werden.');
        return;
      }
      applyCustomerPlace(place);
    });
  };

  const saveTargetCompany = async () => {
    if (!placeForm.place_id) {
      setApiErrors('Bitte wählen Sie ein Unternehmen aus.');
      return;
    }
    setLoading(true);
    try {
      await UserService.updateTargetPlace({
        ...placeForm,
        batch_code: placeCodeRef.current || placeTargetId,
      });
      setPlaceModalOpen(false);
      setApiErrors('');
      loadBatchCodes();
    } catch (error) {
      setApiErrors(error.response?.data?.error || error.response?.data?.message || 'Das Zielunternehmen konnte nicht gespeichert werden.');
    } finally {
      setLoading(false);
    }
  };

  const customerEntryUrl = (batchCode) => {
    const composed = String(batchCode.service_in_url_with_in_url_code_generated || '').trim();
    if (composed) return composed;
    const base = String(batchCode.service_in_url || '').trim();
    const hash = String(batchCode.in_url_code_generated || batchCode.batch_url_hash || '').trim();
    if (base && hash) {
      if (base.endsWith('=') || base.endsWith('/') || base.endsWith('?')) return base + hash;
      return `${base.replace(/\/+$/, '')}/${hash}`;
    }
    return `${directURI || ''}${hash}`;
  };

  

  


  
  
  

  const formatDay = (value) => {
    if (!value) return "keine Angabe";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString("de-DE");
  };
  const periodLabel = (value) => ({ monthly: "monatlich", yearly: "jährlich", weekly: "wöchentlich", daily: "täglich", onetime: "einmalig" })[String(value || "").toLowerCase()] || value || "keine Angabe";
  const statusLabel = (value) => ({ active: "aktiv", paused: "pausiert", cancelled: "gekündigt", inactive: "inaktiv" })[String(value || "").toLowerCase()] || "keine Angabe";
  const money = (value) => {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return "keine Angabe";
    return `${amount.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} EUR netto`;
  };
  const tariffCode = batchCodes.find((code) => code.batch_code_id === tariffCodeId) || null;

  useEffect(() => {
    if (!tariffCodeId) return undefined;
    let cancelled = false;
    setOffersLoading(true);
    UserService.getUpgradeOffers(tariffCodeId)
      .then((response) => { if (!cancelled) setOffers(response.data?.offers || []); })
      .catch(() => { if (!cancelled) setOffers([]); })
      .finally(() => { if (!cancelled) setOffersLoading(false); });
    return () => { cancelled = true; };
  }, [tariffCodeId]);

  const runSubscription = async (code, action, extra = {}) => {
    if (!code) return;
    setActionBusy(true);
    setActionError("");
    setActionMessage("");
    try {
      const response = await UserService.manageCustomerSubscription(code.batch_code_id, {
        action,
        billing_period: billingPeriod,
        ...extra,
      });
      setActionMessage(response.data?.message || "Die Änderung wurde gespeichert.");
      setConfirmAction("");
      loadBatchCodes();
    } catch (error) {
      setActionError(error.response?.data?.message || "Die Änderung konnte nicht gespeichert werden.");
    } finally {
      setActionBusy(false);
    }
  };

  const dayKey = (value) => {
    const match = String(value || "").match(/^(\d{4}-\d{2}-\d{2})/);
    if (match) return match[1];
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${date.getFullYear()}-${month}-${day}`;
  };
  const todayKey = () => dayKey(new Date());
  const aboState = (code) => String(code?.subscription_status || "inactive").toLowerCase();
  const canActivate = (code) => {
    const state = aboState(code);
    if (state === "active" || state === "cancelled") return false;
    const amount = Number(code?.resale_tariff?.amount_eur_net);
    const free = !Number.isFinite(amount) || amount <= 0;
    const until = dayKey(code?.paid_until || code?.batch_validity_until_date);
    return free || (code?.payment_status === "paid" && until && until >= todayKey());
  };
  const employeeName = (code) => {
    const person = code?.t_employee;
    if (!person || !person.employee_id) return "Inhaber";
    return [person.employees_firstname, person.employees_lastname].filter(Boolean).join(" ") || "Mitarbeiter";
  };

  const activateSubscription = async (code) => {
    if (!code) return;
    setActionBusy(true);
    setActionError("");
    setActionMessage("");
    try {
      const response = await UserService.manageCustomerSubscription(code.batch_code_id, { action: "activate" });
      setActionMessage((response.data && response.data.message) || "Das Abo ist aktiv.");
      loadBatchCodes();
    } catch (error) {
      setActionError((error.response && error.response.data && error.response.data.message) || "Das Abo konnte nicht aktiviert werden.");
    } finally {
      setActionBusy(false);
    }
  };

  const openTariff = (code) => {
    setFocusId(code.batch_code_id);
    setTariffCodeId(code.batch_code_id);
    setActionError("");
    setActionMessage("");
    setConfirmAction("");
  };

  const downloadQr = (batchCode) => {
    if (!batchCode || !batchCode.qr_code) return;
    const link = document.createElement("a");
    link.href = `data:image/png;base64,${batchCode.qr_code}`;
    link.download = "myn-club-qr-code.png";
    link.click();
  };

  const confirmBook = async () => {
    if (!bookOffer) return;
    setBookBusy(true);
    setActionError("");
    setActionMessage("");
    try {
      const response = await UserService.bookCustomerOffer({
        batch_id: bookOffer.batch_id,
        billing_period: bookPeriod,
      });
      setActionMessage((response.data && response.data.message) || "Der QR-Code wurde gebucht.");
      setBookOffer(null);
      setSearchTerm("");
      setPickedId(null);
      if (currentPage !== 1) setCurrentPage(1);
      else loadBatchCodes();
    } catch (error) {
      setActionError((error.response && error.response.data && error.response.data.message) || "Die Buchung konnte nicht gespeichert werden.");
    } finally {
      setBookBusy(false);
    }
  };

  const shareUrl = (batchCode) => customerEntryUrl(batchCode) || buildPublicRedeemUrl(String(batchCode?.in_url_code_generated || batchCode?.batch_url_hash || batchCode?.batch_code || "").trim());

  const billingLine = (code) => {
    const amount = Number(code?.resale_tariff?.amount_eur_net);
    if (!code?.resale_tariff || !Number.isFinite(amount)) return { label: "Hinweis", value: "Ohne Berechnung" };
    if (amount <= 0) return { label: "Hinweis", value: "Gratis" };
    if (code.payment_status === "paid") {
      return { label: "Bezahlt bis", value: formatDay(code.paid_until || code.batch_validity_until_date) };
    }
    if (code.payment_status === "canceled") return { label: "Rechnung", value: "storniert" };
    if (code.invoice_number) return { label: "Rechnung", value: `offen, ${code.invoice_number}` };
    return { label: "Rechnung", value: "offen" };
  };

  const codeLabel = (code) => String(code?.in_url_code_generated || code?.batch_url_hash || code?.batch_code || "").trim();

  const targetUrlOf = (code) => {
    const placeId = String(code?.place_id || "").trim();
    const stored = String(code?.target_url || code?.service_out_url_with_place_id || "").trim();
    if (stored && placeId && stored.includes(placeId)) return stored;
    const base = String(code?.service_out_url || "").trim();
    if (base && placeId && /[=\/?]$/.test(base)) return base + placeId;
    return stored || base;
  };

  const matchesQuery = (code, query) => {
    const needle = String(query || "").trim().toLowerCase();
    if (!needle) return true;
    const haystack = [code?.batch_name, code?.service_name, codeLabel(code), code?.place_name, code?.place_address, targetUrlOf(code)].join(" ").toLowerCase();
    return haystack.includes(needle);
  };

  const matchesOffer = (offer, query) => {
    const needle = String(query || "").trim().toLowerCase();
    if (!needle) return true;
    const service = offer?.service || {};
    const tariff = offer?.tariff || {};
    const haystack = [offer?.batch_name, service.service_name, service.description, service.ad_text, tariff.tariff_name].join(" ").toLowerCase();
    return haystack.includes(needle);
  };

  const shareQrCode = (batchCode, channel) => {
    const url = shareUrl(batchCode);
    const title = batchCode.batch_name || "MYN.CLUB QR-Code";
    const text = `${title}\n${url}`;
    const channelUrl = channel === "telegram"
      ? `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`
      : `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(channelUrl, "_blank", "noopener,noreferrer");
  };

  const visibleCodes = batchCodes.filter((code) => (pickedId ? code.batch_code_id === pickedId : matchesQuery(code, searchTerm)));
  const visibleOffers = catalogOffers.filter((offer) => matchesOffer(offer, searchTerm));
  const suggestions = [
    ...batchCodes.filter((code) => matchesQuery(code, searchTerm)).map((code) => ({
      kind: "code",
      key: `code-${code.batch_code_id}`,
      title: code.batch_name || code.service_name || "QR-Code",
      subtitle: [code.service_name, codeLabel(code)].filter(Boolean).join(" · "),
      code,
    })),
    ...catalogOffers.filter((offer) => matchesOffer(offer, searchTerm)).map((offer) => ({
      kind: "offer",
      key: `offer-${offer.batch_id}`,
      title: (offer.service && offer.service.service_name) || offer.batch_name || "Angebot",
      subtitle: offer.batch_name || "",
      offer,
    })),
  ];

  return (
    <>
      <section className="myn-sheet">
        <header className="myn-sheet__head">
          <span className="myn-sheet__icon" aria-hidden="true"><FaQrcode /></span>
          <div>
            <p className="myn-sheet__kicker">Zugang</p>
            <h1 className="myn-sheet__title">Meine QR-Codes</h1>
            <p className="myn-sheet__lead">Hier liegen Ihre gebuchten QR-Codes. Tarif, Zieladresse und Teilen öffnen Sie über die Symbole auf der Karte. Die Zuordnung an Mitarbeiter liegt im Reiter Mitarbeiter.</p>
          </div>
        </header>
        <div className="myn-sheet__tabs" role="tablist" aria-label="QR-Codes">
          <button type="button" role="tab" aria-selected={pageTab === "codes"} className={pageTab === "codes" ? "myn-sheet__tab is-active" : "myn-sheet__tab"} onClick={() => setPageTab("codes")}><FaQrcode aria-hidden="true" /><span>Meine QR-Codes</span></button>
          <button type="button" role="tab" aria-selected={pageTab === "mitarbeiter"} className={pageTab === "mitarbeiter" ? "myn-sheet__tab is-active" : "myn-sheet__tab"} onClick={() => setPageTab("mitarbeiter")}><FaUser aria-hidden="true" /><span>Mitarbeiter</span></button>
        </div>
        {apiErrors && <Alert variant="danger">{apiErrors}</Alert>}
        {actionError && <Alert variant="danger">{actionError}</Alert>}
        {actionMessage && <Alert variant="success">{actionMessage}</Alert>}
        <div className="myn-suggest" onBlur={(event) => { if (!event.currentTarget.contains(event.relatedTarget)) setSearchOpen(false); }}>
          <Form.Label htmlFor="searchBatchCode">Suchen</Form.Label>
          <Form.Control
            id="searchBatchCode"
            type="text"
            placeholder="Produkt, Unternehmen, Name oder Code"
            value={searchTerm}
            autoComplete="off"
            aria-expanded={searchOpen}
            aria-controls="qr-search-list"
            onFocus={() => setSearchOpen(true)}
            onClick={() => setSearchOpen(true)}
            onChange={handleSearchChange}
          />
          {searchOpen && (
            <ul id="qr-search-list" role="listbox" className="myn-suggest__list">
              {suggestions.length === 0 && <li className="myn-suggest__empty">Kein Treffer</li>}
              {suggestions.map((item) => (
                <li key={item.key}>
                  <button
                    type="button"
                    role="option"
                    onClick={() => {
                      if (item.kind === "code") {
                        setPickedId(item.code.batch_code_id);
                        setSearchTerm(item.code.batch_name || item.code.service_name || codeLabel(item.code));
                        setFocusId(item.code.batch_code_id);
                      } else {
                        setPickedId(null);
                        setSearchTerm(item.title);
                      }
                      setSearchOpen(false);
                    }}
                  >
                    <strong>{item.title}</strong>
                    <span>{item.kind === "offer" ? `Buchbar · ${item.subtitle}` : item.subtitle}</span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
        {loading && <p className="myn-sheet__muted"><Spinner animation="border" size="sm" /> Wird geladen …</p>}

        {pageTab === "mitarbeiter" && (
          <>
            <h2 className="myn-sheet__subtitle">Mitarbeiter-QR-Codes</h2>
            <p className="myn-sheet__lead">Die Auswahl legt fest, welchem Mitarbeiter die Klicks dieses QR-Codes zugeordnet werden. Die Auswertung sehen Sie unter Klicks meiner Mitarbeiter. Inhaber bedeutet, die Klicks bleiben bei Ihrem Konto.</p>
            {employees.length === 0 && <p>Es sind noch keine Mitarbeiter angelegt. Neue Mitarbeiter legen Sie unter Einstellungen und dann Mitarbeiter an.</p>}
            {visibleCodes.length === 0 && !loading && <p>Keine QR-Codes vorhanden.</p>}
            <div className="myn-gallery">
              {visibleCodes.map((batchCode) => (
                <article className="myn-code-card" key={`staff-${batchCode.batch_code_id}`}>
                  <p className="myn-code-card__service">{batchCode.service_name || "QR-Code"}</p>
                  <h2>{batchCode.batch_name || "QR-Code"}</h2>
                  <p>{codeLabel(batchCode)}</p>
                  <Form.Group>
                    <Form.Label>Mitarbeiter</Form.Label>
                    <Form.Select aria-label="Mitarbeiter wählen" value={batchCode.t_employee?.employee_id || ""} onChange={(event) => handleEmployeeChange(event, batchCode.batch_code_id)}>
                      <option value="">Inhaber</option>
                      {employees.map((employee) => (
                        <option key={employee.employee_id} value={employee.employee_id}>{employee.employees_firstname} {employee.employees_lastname}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </article>
              ))}
            </div>
          </>
        )}

        {pageTab === "codes" && (
        <>
        <h2 className="myn-sheet__subtitle">Ihre QR-Codes</h2>
        {visibleCodes.length === 0 && !loading && <p>Keine QR-Codes vorhanden.</p>}
        <div className="myn-code-list">
          {visibleCodes.map((batchCode) => {
            const tariff = batchCode.resale_tariff || {};
            const targetUrl = targetUrlOf(batchCode);
            return (
              <article className="myn-code-card myn-code-card--row" key={batchCode.batch_code_id}>
                <div className="myn-code-card__tools">
                  <button type="button" className="myn-icon-btn" aria-label="Tarif" title="Tarif" onClick={() => openTariff(batchCode)}><FaTag aria-hidden="true" /></button>
                  <button type="button" className="myn-icon-btn" aria-label="Einstellungen" title="Einstellungen" onClick={() => setSettingsCode(batchCode)}><FaCog aria-hidden="true" /></button>
                  <button type="button" className="myn-icon-btn" aria-label="Teilen" title="Teilen" onClick={() => setShareCode(batchCode)}><FaShareAlt aria-hidden="true" /></button>
                </div>
                <div className="myn-code-card__top">
                  {batchCode.qr_code ? (
                    <a href={shareUrl(batchCode)} target="_blank" rel="noopener noreferrer">
                      <img className="myn-code-card__qr" src={`data:image/png;base64,${batchCode.qr_code}`} alt="QR-Code" />
                    </a>
                  ) : <div className="myn-code-card__qr myn-code-card__qr--empty">Kein QR-Code</div>}
                  <div className="myn-code-card__body">
                    {batchCode.service_name && <p className="myn-code-card__service">{batchCode.service_name}</p>}
                    <h2>{batchCode.batch_name || "QR-Code"}</h2>
                    <p>{codeLabel(batchCode)}</p>
                    <p><strong>{tariff.tariff_name || "kein Tarif"}</strong> · {money(tariff.amount_eur_net)} · {periodLabel(tariff.amount_period_net)}</p>
                  </div>
                </div>
                <p className="myn-code-card__url">
                  <span>Zieladresse</span>
                  {targetUrl ? <a href={targetUrl} target="_blank" rel="noopener noreferrer">{targetUrl}</a> : <strong>noch nicht eingestellt</strong>}
                </p>
                <div className="myn-code-card__places-wrap">
                  <p className="myn-code-card__label">Zielunternehmen</p>
                  <ul className="myn-code-card__places">
                    {batchCode.place_name ? (
                      <li>
                        <strong>{batchCode.place_name}</strong>
                        {batchCode.place_address && <span>{batchCode.place_address}</span>}
                      </li>
                    ) : <li>noch nicht eingestellt</li>}
                  </ul>
                </div>
                <div className="myn-sheet__grid">
                  <p className="myn-sheet__link"><span>Gültig von</span><strong>{formatDay(batchCode.batch_validity_from_date)}</strong></p>
                  <p className="myn-sheet__link"><span>Gültig bis</span><strong>{formatDay(batchCode.batch_validity_until_date)}</strong></p>
                  <p className="myn-sheet__link"><span>{billingLine(batchCode).label}</span><strong>{billingLine(batchCode).value}</strong></p>
                  <p className="myn-sheet__link"><span>Abo</span><strong>{statusLabel(batchCode.subscription_status)}</strong></p>
                  <p className="myn-sheet__link"><span>Mitarbeiter</span><strong>{employeeName(batchCode)}</strong></p>
                </div>
                {aboState(batchCode) !== "active" && aboState(batchCode) !== "cancelled" && (
                  <div className="myn-code-card__note">
                    <p className="myn-sheet__lead">{canActivate(batchCode)
                      ? "Das Abo wurde beim Anlegen nicht gestartet. Die bezahlte Laufzeit bleibt bestehen. Aktivieren erzeugt keine neue Rechnung."
                      : "Das Abo startet erst mit einer bezahlten Laufzeit. Öffnen Sie Tarif und wählen Sie Verlängern."}</p>
                    {canActivate(batchCode) && (
                      <Button className="myn-btn myn-btn--primary" disabled={actionBusy} onClick={() => activateSubscription(batchCode)}>Abo aktivieren</Button>
                    )}
                  </div>
                )}
              </article>
            );
          })}
        </div>

        <h2 className="myn-sheet__subtitle">Weitere Dienste buchen</h2>
        <p className="myn-sheet__lead">Hier können Sie weitere QR-Codes für andere Dienste buchen. Die Suche oben gilt auch für diese Angebote.</p>
        {!catalogReady && <p className="myn-sheet__muted"><Spinner animation="border" size="sm" /> Angebote werden geladen …</p>}
        {catalogReady && visibleOffers.length === 0 && <p>Kein buchbares Angebot für diese Suche.</p>}
        <div className="myn-gallery">
          {visibleOffers.map((offer) => {
            const soldOut = Number(offer.available) <= 0;
            return (
              <article className="myn-code-card" key={`offer-${offer.batch_id}`}>
                <p className="myn-code-card__service">{(offer.service && offer.service.service_name) || "Dienst"}</p>
                <h2>{offer.batch_name || "QR-Code"}</h2>
                <p>{(offer.tariff && offer.tariff.tariff_name) || "Tarif"} · {money(offer.tariff && offer.tariff.amount_eur_net)} · {periodLabel(offer.tariff && offer.tariff.amount_period_net)}</p>
                {offer.service && offer.service.ad_text && <p>{offer.service.ad_text}</p>}
                <p>{soldOut ? "Vergriffen" : `Noch ${offer.available} frei`}</p>
                <Button className="myn-btn myn-btn--primary" disabled={soldOut} onClick={() => { setBookOffer(offer); setBookPeriod("monthly"); setActionError(""); }}>Buchen</Button>
              </article>
            );
          })}
        </div>
        </>
        )}

        {totalPages > 1 && (
          <div className="myn-sheet__pager">
            <Button className="myn-btn myn-btn--ghost" disabled={currentPage <= 1} onClick={() => setCurrentPage(currentPage - 1)}>Zurück</Button>
            <span>Seite {currentPage} von {totalPages}</span>
            <Button className="myn-btn myn-btn--ghost" disabled={currentPage >= totalPages} onClick={() => setCurrentPage(currentPage + 1)}>Weiter</Button>
          </div>
        )}
      </section>

      <Modal show={!!tariffCode} onHide={() => { setTariffCodeId(null); setConfirmAction(""); }}>
        <Modal.Header closeButton>
          <Modal.Title>Tarif</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {tariffCode && (
            <>
              <h2 className="myn-sheet__title">{tariffCode.batch_name || "QR-Code"}</h2>
              <div className="myn-sheet__grid">
                <article className="myn-sheet__tile"><FaTag aria-hidden="true" /><span>Tarif</span><strong>{tariffCode.resale_tariff?.tariff_name || "keine Angabe"}</strong></article>
                <article className="myn-sheet__tile"><FaTag aria-hidden="true" /><span>Betrag</span><strong>{money(tariffCode.resale_tariff?.amount_eur_net)}</strong></article>
                <article className="myn-sheet__tile"><FaTag aria-hidden="true" /><span>Zeitraum</span><strong>{periodLabel(tariffCode.resale_tariff?.amount_period_net)}</strong></article>
                <article className="myn-sheet__tile"><FaTag aria-hidden="true" /><span>Gültig bis</span><strong>{formatDay(tariffCode.batch_validity_until_date)}</strong></article>
                <article className="myn-sheet__tile"><FaTag aria-hidden="true" /><span>{billingLine(tariffCode).label}</span><strong>{billingLine(tariffCode).value}</strong></article>
                <article className="myn-sheet__tile"><FaTag aria-hidden="true" /><span>Rechnung</span><strong>{Number(tariffCode.resale_tariff?.amount_eur_net) > 0 ? (tariffCode.invoice_number ? `${tariffCode.invoice_number}, ${tariffCode.payment_label}` : tariffCode.payment_label) : "Ohne Berechnung"}</strong></article>
              </div>
              <div className="myn-sheet__tabs" role="group" aria-label="Zahlweise">
                <button type="button" className={billingPeriod === "monthly" ? "myn-sheet__tab is-active" : "myn-sheet__tab"} onClick={() => setBillingPeriod("monthly")}>Monatlich</button>
                <button type="button" className={billingPeriod === "yearly" ? "myn-sheet__tab is-active" : "myn-sheet__tab"} onClick={() => setBillingPeriod("yearly")}>Jährlich</button>
              </div>
              <div className="myn-actions">
                <Button className="myn-btn myn-btn--primary" disabled={actionBusy} onClick={() => setConfirmAction("extend")}>Verlängern</Button>
                <Button className="myn-btn myn-btn--ghost" disabled={actionBusy || tariffCode.subscription_status === "cancelled"} onClick={() => setConfirmAction("cancel")}>Kündigen</Button>
              </div>
              {confirmAction === "extend" && (
                <div className="myn-sheet__review">
                  <p>Der QR-Code wird um einen Abrechnungszeitraum verlängert. Dafür wird eine Rechnung erstellt.</p>
                  <div className="myn-actions">
                    <Button className="myn-btn myn-btn--primary" disabled={actionBusy} onClick={() => runSubscription(tariffCode, "extend")}>Verlängerung bestätigen</Button>
                    <Button className="myn-btn myn-btn--ghost" onClick={() => setConfirmAction("")}>Abbrechen</Button>
                  </div>
                </div>
              )}
              {confirmAction === "cancel" && (
                <div className="myn-sheet__review">
                  <p>Die Kündigung beendet das Abo. Der QR-Code bleibt bis zum Ende der bereits bezahlten Laufzeit nutzbar.</p>
                  <div className="myn-actions">
                    <Button className="myn-btn myn-btn--danger" disabled={actionBusy} onClick={() => runSubscription(tariffCode, "cancel")}>Kündigung bestätigen</Button>
                    <Button className="myn-btn myn-btn--ghost" onClick={() => setConfirmAction("")}>Abbrechen</Button>
                  </div>
                </div>
              )}
              <h2 className="myn-sheet__subtitle">Upgrade</h2>
              {offersLoading && <p className="myn-sheet__muted"><Spinner animation="border" size="sm" /> Tarife werden geladen …</p>}
              {!offersLoading && offers.length === 0 && <p>Kein höherer Tarif ist verfügbar.</p>}
              <div className="myn-sheet__stack">
                {offers.map((offer) => (
                  <article className="myn-sheet__review" key={offer.tariff.tariff_id}>
                    <h2>{offer.tariff.tariff_name}</h2>
                    <p>{offer.service?.service_name || offer.batch_name}</p>
                    <p><strong>{money(offer.tariff.amount_eur_net)}</strong> · {periodLabel(offer.tariff.amount_period_net)}</p>
                    <Button className="myn-btn myn-btn--primary" disabled={actionBusy} onClick={() => runSubscription(tariffCode, "upgrade", { tariff_id: offer.tariff.tariff_id })}>Auf diesen Tarif wechseln</Button>
                  </article>
                ))}
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={!!settingsCode} onHide={() => setSettingsCode(null)}>
        <Modal.Header closeButton>
          <Modal.Title>Einstellungen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {settingsCode && (
            <>
              <h2 className="myn-sheet__title">{settingsCode.batch_name || "QR-Code"}</h2>
              <p>{codeLabel(settingsCode)}</p>
              <p className="myn-sheet__lead">Hier stellen Sie ein, auf welches Unternehmen das Bewertungsformular führt. Werbeflyer und Kontaktdaten der Visitenkarte gehören zum selben QR-Code.</p>
              <div className="myn-actions">
                <Button className="myn-btn myn-btn--primary" onClick={() => { const code = settingsCode; setSettingsCode(null); openPlaceModal(code); }}><FaMapMarkerAlt aria-hidden="true" /> Zieladresse einstellen</Button>
                <Button className="myn-btn myn-btn--ghost" disabled={!settingsCode.place_id} onClick={() => { const code = settingsCode; setSettingsCode(null); openPromoModal(code); }}>Werbeplatz und Flyer</Button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={!!shareCode} onHide={() => setShareCode(null)}>
        <Modal.Header closeButton>
          <Modal.Title>Teilen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {shareCode && (
            <div className="myn-actions">
              <Button className="myn-btn myn-btn--whatsapp" onClick={() => shareQrCode(shareCode, "whatsapp")}><FaWhatsapp aria-hidden="true" /> WhatsApp</Button>
              <Button className="myn-btn myn-btn--telegram" onClick={() => shareQrCode(shareCode, "telegram")}><FaTelegramPlane aria-hidden="true" /> Telegram</Button>
              <Button className="myn-btn myn-btn--ghost" onClick={() => downloadQr(shareCode)}><FaDownload aria-hidden="true" /> Herunterladen</Button>
            </div>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={!!bookOffer} onHide={() => { if (!bookBusy) setBookOffer(null); }}>
        <Modal.Header closeButton>
          <Modal.Title>QR-Code buchen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {bookOffer && (
            <>
              <h2 className="myn-sheet__title">{(bookOffer.service && bookOffer.service.service_name) || "Dienst"}</h2>
              <p>{bookOffer.batch_name}</p>
              <p><strong>{bookOffer.tariff && bookOffer.tariff.tariff_name}</strong> · {money(bookOffer.tariff && bookOffer.tariff.amount_eur_net)} · {periodLabel(bookOffer.tariff && bookOffer.tariff.amount_period_net)}</p>
              <p>Mit der Buchung wird ein QR-Code diesem Konto zugeordnet. Bei einem kostenpflichtigen Tarif entsteht eine Rechnung unter Meine Rechnungen.</p>
              <div className="myn-sheet__tabs" role="group" aria-label="Zahlweise">
                <button type="button" className={bookPeriod === "monthly" ? "myn-sheet__tab is-active" : "myn-sheet__tab"} onClick={() => setBookPeriod("monthly")}>Monatlich</button>
                <button type="button" className={bookPeriod === "yearly" ? "myn-sheet__tab is-active" : "myn-sheet__tab"} onClick={() => setBookPeriod("yearly")}>Jährlich</button>
              </div>
              <div className="myn-actions">
                <Button className="myn-btn myn-btn--primary" disabled={bookBusy} onClick={confirmBook}>Buchung bestätigen</Button>
                <Button className="myn-btn myn-btn--ghost" disabled={bookBusy} onClick={() => setBookOffer(null)}>Abbrechen</Button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={placeModalOpen} onHide={() => setPlaceModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Zielunternehmen ändern</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {apiErrors && <Alert variant="danger">{apiErrors}</Alert>}
          <LoadScript googleMapsApiKey={MAP_API_KEY} libraries={MAP_LIBRARIES}>
            <GoogleMap
              mapContainerStyle={{ height: '320px', width: '100%' }}
              center={markerPosition}
              zoom={13}
              onLoad={setPlaceMap}
              onUnmount={() => setPlaceMap(null)}
            >
              <div style={{ position: 'absolute', top: 10, left: 10, zIndex: 5, right: 10 }}>
                <GoogleAutocomplete
                  onLoad={(instance) => { placeAutocompleteRef.current = instance; }}
                  onPlaceChanged={() => {
                    const instance = placeAutocompleteRef.current;
                    if (instance) applyCustomerPlace(instance.getPlace());
                  }}
                >
                  <input
                    type="text"
                    placeholder="Unternehmen und Standort eingeben"
                    aria-label="Unternehmen und Standort eingeben"
                    style={{ width: '100%', maxWidth: 420, height: 44, padding: '0 10px', borderRadius: 6, border: '1px solid #ccc' }}
                  />
                </GoogleAutocomplete>
                {(nearbyLoading || nearbyPlaces.length > 0) && (
                  <div role="listbox" aria-label="Unternehmen in der Nähe" style={{ marginTop: 8, maxHeight: 180, overflowY: 'auto', background: '#fff', borderRadius: 8 }}>
                    {nearbyLoading && <div style={{ padding: 12 }}>Unternehmen werden gesucht …</div>}
                    {nearbyPlaces.map((item) => (
                      <button
                        type="button"
                        key={item.place_id}
                        onClick={() => selectNearbyCompany(item)}
                        style={{ display: 'block', width: '100%', textAlign: 'left', minHeight: 44, padding: '8px 12px', border: 0, borderBottom: '1px solid #eee', background: '#fff' }}
                      >
                        <strong>{item.name}</strong>
                        <br />
                        <span style={{ fontSize: 13 }}>{item.vicinity}</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <button
                type="button"
                title="Mein Standort"
                aria-label="Mein Standort"
                onClick={() => {
                  if (!navigator.geolocation) {
                    setApiErrors('Standort konnte nicht ermittelt werden.');
                    return;
                  }
                  navigator.geolocation.getCurrentPosition((position) => {
                    const next = { lat: position.coords.latitude, lng: position.coords.longitude };
                    setMarkerPosition(next);
                    if (placeMap) {
                      placeMap.setCenter(next);
                      placeMap.setZoom(15);
                    }
                    searchNearbyCompanies(next);
                  }, () => setApiErrors('Standort konnte nicht ermittelt werden.'));
                }}
                style={{ position: 'absolute', right: 10, bottom: 24, width: 44, height: 44, border: 0, borderRadius: 4, background: '#fff', boxShadow: '0 1px 4px rgba(0,0,0,0.3)' }}
              >
                ⊕
              </button>
            </GoogleMap>
          </LoadScript>
          <Form.Group className="mt-3">
            <Form.Label>Unternehmen</Form.Label>
            <Form.Control readOnly value={placeForm.place_name} />
          </Form.Group>
          <Form.Group className="mt-2">
            <Form.Label>Adresse</Form.Label>
            <Form.Control readOnly value={placeForm.place_address} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" style={{ minHeight: 44 }} onClick={() => setPlaceModalOpen(false)}>Schließen</Button>
          <Button variant="primary" style={{ minHeight: 44 }} onClick={saveTargetCompany}>Unternehmen speichern</Button>
        </Modal.Footer>
      </Modal>

      {/* Werbeplatz- & Flyer-Modal */}
      <Modal show={promoModalOpen} onHide={() => setPromoModalOpen(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Werbeplatz &amp; Visitenkarte bearbeiten</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {promoError && <Alert variant="danger">{promoError}</Alert>}
          {promoMessage && <Alert variant="success">{promoMessage}</Alert>}

          <div className="bg-light p-3 rounded mb-3 border">
            <h6 className="mb-1 text-dark">
              {promoTargetCode?.place_name || 'Unternehmen'}
            </h6>
            <div className="small text-muted">{promoTargetCode?.place_address}</div>
            <div className="mt-2">
              <a
                href={`/v/${promoTargetCode?.in_url_code_generated || promoTargetCode?.place_id}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-sm btn-outline-info d-inline-flex align-items-center gap-1"
                style={{ minHeight: 38 }}
              >
                🔍 Visitenkarte live ansehen ➔
              </a>
            </div>
          </div>

          {/* Flyer-Bereich */}
          <div className="border rounded p-3 mb-4 bg-white">
            <h6 className="fw-bold mb-2">Werbeflyer (Bild / Plakat)</h6>
            <p className="text-muted small mb-3">
              Laden Sie ein Foto oder Werbeflyer hoch (JPG, PNG, WebP – max. 5 MB). Der Flyer wird prominent auf Ihrer Visitenkarte und in der Startseiten-Schaukarte angezeigt.
            </p>

            {promoForm.flyer_image_url ? (
              <div className="mb-3">
                <div className="position-relative d-inline-block border rounded overflow-hidden shadow-sm">
                  <img
                    src={promoForm.flyer_image_url}
                    alt="Aktueller Werbeflyer"
                    style={{ maxHeight: 200, maxWidth: "100%", display: "block" }}
                  />
                </div>
                <div className="mt-2">
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={handleFlyerDelete}
                    disabled={flyerUploading}
                    style={{ minHeight: 38 }}
                  >
                    Flyer entfernen
                  </Button>
                </div>
              </div>
            ) : (
              <div className="d-flex flex-wrap gap-2 align-items-center mb-3">
                <Form.Control
                  type="file"
                  accept="image/jpeg,image/png,image/webp,image/gif"
                  onChange={(e) => setFlyerFile(e.target.files?.[0] || null)}
                  style={{ maxWidth: 360 }}
                />
                <Button
                  variant="primary"
                  onClick={handleFlyerUpload}
                  disabled={!flyerFile || flyerUploading}
                  style={{ minHeight: 40 }}
                >
                  {flyerUploading ? 'Wird hochgeladen …' : 'Flyer hochladen'}
                </Button>
              </div>
            )}
          </div>

          {/* Formular für Kontaktdaten & Werbetext */}
          <Form onSubmit={handlePromoSubmit}>
            <div className="row g-3">
              <div className="col-12 col-md-6">
                <Form.Group controlId="promoWebsite">
                  <Form.Label>Firmen-Website (URL)</Form.Label>
                  <Form.Control
                    type="url"
                    placeholder="https://meine-website.de"
                    value={promoForm.website_url}
                    onChange={(e) => setPromoForm({ ...promoForm, website_url: e.target.value })}
                  />
                </Form.Group>
              </div>

              <div className="col-12 col-md-6">
                <Form.Group controlId="promoPhone">
                  <Form.Label>Telefonnummer (Anruf)</Form.Label>
                  <Form.Control
                    type="tel"
                    placeholder="+49 221 1234567"
                    value={promoForm.contact_phone}
                    onChange={(e) => setPromoForm({ ...promoForm, contact_phone: e.target.value })}
                  />
                </Form.Group>
              </div>

              <div className="col-12 col-md-6">
                <Form.Group controlId="promoWhatsapp">
                  <Form.Label>WhatsApp-Nummer (Chat)</Form.Label>
                  <Form.Control
                    type="tel"
                    placeholder="+49 171 1234567"
                    value={promoForm.contact_whatsapp}
                    onChange={(e) => setPromoForm({ ...promoForm, contact_whatsapp: e.target.value })}
                  />
                </Form.Group>
              </div>

              <div className="col-12 col-md-6">
                <Form.Group controlId="promoTitle">
                  <Form.Label>Werbeslogan / Kurztitel</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="z. B. Frisch gebacken in Köln-Mülheim"
                    value={promoForm.promo_title}
                    onChange={(e) => setPromoForm({ ...promoForm, promo_title: e.target.value })}
                  />
                </Form.Group>
              </div>

              <div className="col-12">
                <Form.Group controlId="promoDesc">
                  <Form.Label>Werbetext &amp; Beschreibung</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="Beschreiben Sie Ihr Angebot für Interessenten und Google-Bewerter …"
                    value={promoForm.description}
                    onChange={(e) => setPromoForm({ ...promoForm, description: e.target.value })}
                  />
                </Form.Group>
              </div>

              <div className="col-12">
                <Form.Check
                  type="switch"
                  id="promoActiveSwitch"
                  label="Werbeplatz öffentlich aktiv schalten"
                  checked={promoForm.is_promo_active}
                  onChange={(e) => setPromoForm({ ...promoForm, is_promo_active: e.target.checked })}
                />
              </div>
            </div>

            <div className="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
              <Button variant="secondary" style={{ minHeight: 44 }} onClick={() => setPromoModalOpen(false)}>
                Schließen
              </Button>
              <Button variant="primary" type="submit" disabled={promoLoading} style={{ minHeight: 44 }}>
                {promoLoading ? 'Wird gespeichert …' : 'Werbedaten speichern'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

    </>
  );
};

export default BatchManagerCustomer;
